import { CircleCheck } from 'lucide-react'
import { useState } from 'react'

import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from '../../reusable/table/ComboboxMultiSelectFilter'
import FilterManagementDropdown from '../needs_attention/FilterManagementDropdown'
import { filterByLabelAndValueCallback } from '../needs_attention/utils'
import { type MultipleSelectedValuesFilter } from '../types'

const nextTaskStatusOptions: ComboboxFilterOption<string>[] = [
  { label: 'Pending', value: 'pending' },
  { label: 'Failed', value: 'failed' },
  { label: 'Completed', value: 'completed' },
  { label: 'Canceled', value: 'canceled' },
  { label: 'Excluded', value: 'excluded' },
  { label: 'Processing', value: 'processing' },
]

const NextTaskStatusFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const filteredOptions = nextTaskStatusOptions?.filter(
    filterByLabelAndValueCallback(query)
  )

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[{ groupLabel: 'Next Task Status', options: filteredOptions || [] }]}
        placeholder='Search next task statuses to filter...'
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={nextTaskStatusOptions || []}
          noSelectionText='Next Task Status'
          pluralIdentifier='next task statuses'
        >
          <CircleCheck size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default NextTaskStatusFilter
